module.exports = __webpack_public_path__ + "img/cloud_upload.02d0b919.svg";